export default __webpack_public_path__ + "static/media/q_right_bg.f937f90f.png";